<template>
    <div class="grcform" style="background-color:#f0f1f2;">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"
            v-on:popupopened="SetPopupRef('Dialog')"
            v-on:popupclosed="SetPopupRef('')"
        ></GrcDialog>

        <div class="grc_fullwidth_lane" style="background-color:var(--premgreen); display:none;">
            <div class="grc_maincont_lane">
                <div class="maintitle"><i class="far fa-credit-card" style="margin-right:10px;"></i>{{title}}</div>
            </div>
        </div>

        <div class="grc_fullwidth_lane">
        <div class="grc_maincont_lane" style="padding:10px;">

            <div class="maincont" v-show="showonlyresult==1">
                <div class="payinfo_cont">
                    <div class="payinfo_innercont">
                        <div class="merchant_name">{{MerchantName}}</div>
                        <div class="merchant_address" v-show="MerchantAddress!=''">{{MerchantAddress}}</div>
                        <div class="item_table_title">Megrendelés részletei:</div>
                        <table class="item_table" cellspacing="0" cellpadding="0">
                            <tr v-for="(item, index) in ITEMS" :key="index" :class="['item_tr', index==0 ? 'item_tr_header':'']">
                                <td :class="['item_td', 'item_td_40', item.IsSumRow==1 ? 'item_td_sumrow' : '']" style="text-align:left;" valign="top">
                                    {{item.DESCRIPTION}}
                                    <div class="item_qty_amount_small" v-show="(index>0)&&(index<(ITEMS.length-1))">{{item.QTY}} x {{item.AMOUNT}}</div>
                                </td>
                                <td :class="['item_td', 'item_td_20', 'item_td_onlybig', item.IsSumRow==1 ? 'item_td_sumrow' : '']" style="text-align:right;" valign="top">{{item.QTY}}</td>
                                <td :class="['item_td', 'item_td_20', 'item_td_onlybig', item.IsSumRow==1 ? 'item_td_sumrow' : '']" style="text-align:right;" valign="top">{{item.AMOUNT}}</td>
                                <td :class="['item_td', 'item_td_20', item.IsSumRow==1 ? 'item_td_sumrow' : '']" style="text-align:right;" valign="top">{{item.AMOUNT_SUM}}</td>
                            </tr>
                        </table>

                        <div class="payinfo_joginfo" style="display:none;"></div>
                    </div>
                </div>
                <div class="payment_cont">
                    <frmVPOS_Azonositas ref="Azonositas" />
                </div>

            </div>

            <div class="maincont" v-show="showonlyresult==2">
                <div class="noaction">
                    <div class="payment_form_content">
                        <div class="innerform_title">FIZETÉS</div>
                        <div class="noaction_text" v-html="NoActionInfoText"></div>
                    </div>
                </div>
            </div>



        </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCombo from '../GrcComponents/GrcCombo.vue'
import GrcText from '../GrcComponents/GrcText.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'

import frmVPOS_Azonositas from '../frmVPOS/frmVPOS_Azonositas.vue'



export default {
  name: 'frmVPOS',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCombo,
      GrcText,
      GrcCheckboxMobile,
      frmVPOS_Azonositas,
  },
  props: {
  },
  data () {
      return {
            WSPREFIX: "frmVPOS",
            gPopupControlName:"",

            innerformid:10,

            title:"",
            MerchantName:"",
            MerchantAddress:"",

            PayHeaderID:0,
            PayRefNum:"",

            showonlyresult:0,
            NoActionInfoText:"",

            ITEMS: [],
            /*
                { DESCRIPTION: "Termék / Szolgáltatás", QTY:"Mennyiség", AMOUNT: "Egységár", AMOUNT_SUM:"Összesen", IsSumRow:0  },
                { DESCRIPTION: "2021.03.28 10:00 Gerinc CT", QTY:"1", AMOUNT: "62 000 Ft", AMOUNT_SUM:"62 000 Ft", IsSumRow:0  },
                { DESCRIPTION: "Vérnyomásmérő", QTY:"2", AMOUNT: "12 000 Ft", AMOUNT_SUM:"24 000 Ft", IsSumRow:0  },
                { DESCRIPTION: "Fizetendő:", QTY:"", AMOUNT: "", AMOUNT_SUM:"86 000 Ft", IsSumRow:1  },
            ],
            */

      }
  },
  model: {
  },  
  methods:{

    NavToForm(pIndex)
    {
        this.innerformid = pIndex;
    },

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmVPOS", pCompName);
    },

    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }

        this.$refs[pNextComp].SetFocus();
    },


    SetLang()
    {
        this.title = "Fizető app"; // this.GetTextBookItem("title");

        this.Init();
    },

      HideErrors()
      {
        //this.$refs.ErrorBox.HideError();
      },

    async Init()
    {
        var param_refnum = "";
        var InitType = 0;

        if ((GRCAPP_GetParameters.ALIAS == "vpos") && (GRCAPP_GetParameters.PC_REFNUM != "") && (GRCAPP_GetParameters.PC_REFNUM != undefined))
        {
            param_refnum = GRCAPP_GetParameters.PC_REFNUM;

            GRCAPP_GetParameters.PC_REFNUM = "";

            InitType = 2;
        }
        else
        {
            InitType = 1;
        }

        this.PayHeaderID = 0;
        this.PayRefNum = "";

        this.$refs.GRCDB.ShowLoading(false);

        var pShopParams = "";

        if (GRCAPP_PostParameters.PAYPARAMS == undefined) { pShopParams = ""; }
        else { pShopParams = GRCAPP_PostParameters.PAYPARAMS; }

        var pAgent = grcmain_GetAgent()+": "+navigator.userAgent;
        if (typeof pAgent == "undefined") { pAgent = "unknown"; }
        
        var QP = {
            sSessionID: "[APPSESSIONID]",
            sIPAddress: "[IPADDRESS]",
            sBrowserAgent: pAgent,
            sShopParams: pShopParams,
            sPC_REFNUM: param_refnum,
            iInitType: InitType,
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_Init", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
            }
            return;
        }

        //console.log(Q);

        if (Q.RESULT[0].StatusID != 1)
        {
            this.$refs.GRCDB.HideLoading();
            this.showonlyresult = 2;
            this.NoActionInfoText = Q.RESULT[0].NoActionInfoText;
            return;
        }

        this.showonlyresult = 1;

        if (Q.RESULT[0].PayHeaderID > 0)
        {
            this.ITEMS = Q.PAYDETAILS;
        }

        var Fizetendo = "";
        if (Q.PAYHEADER.length > 0)
        {
            this.MerchantName = Q.PAYHEADER[0].MERCHANT_NAME;
            this.MerchantAddress = Q.PAYHEADER[0].ADDRESS;

            this.PayHeaderID = Q.PAYHEADER[0].PayHeaderID;
            this.PayRefNum = Q.PAYHEADER[0].REFNUM;
            Fizetendo = Q.PAYHEADER[0].Fizetendo;
        }

        this.$refs.Azonositas.Init(Q.TAGADAT, this.PayHeaderID, this.PayRefNum, Fizetendo, Q.BANKKARTYA);


        this.$refs.GRCDB.HideLoading();

    },


    async ShowInfoDialog(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = 20;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },

  created()
  {

  },

  mounted()
  {
    this.$emit("changepagebg", "#f0f1f2");
    this.$emit("setappheaderversion", "fizetoapp");
    gForm = this;
    gPopupControlName = "";

    if (gAppInitDone)
    {
      this.SetLang();
    }
  }

}


</script>


<style scoped>

.maintitle
{
    width: 100%;
    box-sizing: border-box;
    color:#fff;
    font-family: "PremiumDefault";
    font-size:22px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px;
}

.innerform
{
    width:100%;
    box-sizing: border-box;
}

.maincont
{
    width:100%;
    box-sizing: border-box;
    padding:0px;
    margin:0px;
}

.payinfo_cont
{
    width: 70%;
    box-sizing: border-box;
    border: none;
    display: inline-block;
    margin:0px;
    padding:10px;
    padding-left: 0px;
    vertical-align: top;
}

.payment_cont
{
    width: 30%;
    box-sizing: border-box;
    border: none;
    display: inline-block;
    margin:0px;
    padding:10px;
    padding-left: 0px;
    vertical-align: top;
}

.payinfo_joginfo
{
    width: 100%;
    box-sizing: border-box;
    border-top:solid 1px #ccc;
    font-family: 'PremiumDefault';
    font-size:13px;
    line-height: 16px;
    text-align: center;
    color:444;
    margin-top:30px;
    padding-top:10px;
}

.payinfo_innercont {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    display: block;    
    padding:10px;

    border: 1px solid #bbb;
    border-radius: 5px;
    -webkit-box-shadow: 0px 0px 5px 2px #ccc;
    box-shadow: 0px 0px 5px 2px #ccc;
}


.merchant_name
{
    width:100%;
    box-sizing: border-box;
    font-family: 'PremiumDefault';
    font-size:18px;
    line-height: 22px;
    color: var(--premblue);
    font-weight: 500;
}

.merchant_address
{
    width:100%;
    box-sizing: border-box;
    font-family: 'PremiumDefault';
    font-size:14px;
    line-height: 18px;
    color:#888;
}

.item_table_title
{
    width:100%;
    box-sizing: border-box;
    font-family: 'PremiumDefault';
    font-size: 15px;
    line-height: 20px;
    color: coral;
    margin-top: 20px;
    margin-bottom: 4px;
    display: none;
}

.item_table
{
    width:100%;
    font-family: 'PremiumDefault';
    font-size:15px;
    line-height: 18px;
    color:#888;
    margin-top: 20px;
}

.item_tr
{
    
}

.item_td
{
    border-bottom:solid 1px #e0e0e0;
    padding: 4px 0px;
}

.item_td_40
{
    width:40%;
}

.item_td_20
{
    width:20%;
}


.item_tr_header
{
    font-weight: 500;
    color: var(--premblue);
}


.item_td_sumrow
{
    border:none;
    font-weight: 500;
    color: var(--premblue);
}

.item_qty_amount_small
{
    width:100%;
    box-sizing: border-box;
    font-size:13px;
    line-height: 13px;
    color:#666;
    display:none;
}

.item_td_onlybig
{
    display:table-cell;
}


.innerform_title
{
    width:100%;
    box-sizing: border-box;
    font-size:13px;
    line-height: 13px;
    text-align: center;
    font-weight: 500;
    letter-spacing: 1px;    
    padding: 5px;
    background-color: dodgerblue;
    color: #fff;
    -webkit-box-shadow: 0px 3px 5px #aaa;
    box-shadow: 0px 3px 5px #aaa;    
}


.btncont
{
  width:100%;
  box-sizing: border-box;
  text-align: center;
}

.noaction
{
    width:100%;
    box-sizing: border-box;
    max-width: 500px;
    margin: 10px auto;

    min-height: 263px;
    background-color: #fff;
    display: block;

    border: 1px solid #bbb;
    border-radius: 5px;
    -webkit-box-shadow: 0px 0px 5px 2px #ccc;
    box-shadow: 0px 0px 5px 2px #ccc;

    padding:0px;
    text-align: center;
    font-size: 16px;
    line-height: 20px;
}

.payment_form_content
{
    width:100%;
    box-sizing: border-box;
    padding:0px;
    margin:0px auto;
}


.noaction_text
{
    width:100%;
    box-sizing: border-box;
    padding:10px;
}

.innerform_title
{
    width:100%;
    box-sizing: border-box;
    font-size:20px;
    line-height: 20px;
    text-align: center;
    font-weight: 500;
    letter-spacing: 1px;    
    padding: 27px 5px 25px 5px;
    background-color: dodgerblue;
    color: #fff;
    -webkit-box-shadow: 0px 3px 5px #aaa;
    box-shadow: 0px 3px 5px #aaa;    
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    background-color: var(--premblue);
}

>>> .fizres_osszeg
{
    width:100%;
    box-sizing: border-box;
    font-size:40px;
    line-height: 40px;
    color: var(--premblue);
    text-align: center;
    font-weight: 500;
    letter-spacing: 1px;
    margin: 15px 0px 5px 0px;

}

>>> .fizres_osszeg_label
{
    width:100%;
    box-sizing: border-box;
    font-size:20px;
    line-height: 20px;
    color: #999;
    text-align: center;
    font-weight: normal;
    letter-spacing: 1px;
    margin: 20px 0px 0px 0px;
}

>>> .fizres_statusznev
{
    width:100%;
    box-sizing: border-box;
    font-size:20px;
    line-height: 20px;
    color: #999;
    text-align: center;
    font-weight: normal;
    letter-spacing: 1px;
    margin: 20px 0px 0px 0px;
}

>>> .fizres_ksz_engedelyszam
{
    width:100%;
    box-sizing: border-box;
    font-size:18px;
    line-height: 22px;
    color: #999;
    text-align: center;
    font-weight: normal;
    letter-spacing: 1px;
    margin: 40px 0px 20px 0px;
}





@media (max-width:1200px)
{
    .payinfo_cont
    {
        width: 64%;
    }

    .payment_cont
    {
        width: 36%;
    }

}

@media (max-width:1000px)
{
    .payinfo_cont
    {
        width: 60%;
    }

    .payment_cont
    {
        width: 40%;
    }

}

@media (max-width:950px)
{
    .payinfo_cont
    {
        width: 50%;
    }

    .payment_cont
    {
        width: 50%;
    }

    .item_qty_amount_small
    {
        display:block;
    }

    .item_td_onlybig
    {
        display:none;
    }
}

@media (max-width:750px)
{
    .payinfo_cont
    {
        width: 100%;
        padding-right: 0px;
    }

    .payment_cont
    {
        width: 100%;
        padding-right: 0px;
    }

    .item_qty_amount_small
    {
        display:block;
    }

    .item_td_onlybig
    {
        display:none;
    }
}

@media (max-width:400px)
{
    .payinfo_cont
    {
        width: 100%;
        padding-right: 0px;
    }

    .payment_cont
    {
        width: 100%;
        padding-right: 0px;
    }

    .item_qty_amount_small
    {
        display:block;
    }

    .item_td_onlybig
    {
        display:none;
    }

    .item_table
    {
        font-size:13px;
        line-height: 16px;
    }

}

</style>